(ns dashboard.db
  (:require
   [cljs.reader :refer [read-string]]
   [re-frame.core :refer [reg-cofx]]
   [malli.core :as mc]
   [malli.transform :as mt]
   [malli.generator :as mg]
   ["date-fns" :refer [sub]]))

(def demo-user
  {:uuid "97bda55b-6175-4c39-9e04-7c0205c709dc"
   :firstName "John"
   :lastName "Doe"
   :title "Store Manager"
   :email "john.doe@example.com"
   :created_at "2022-05-05T14:07:30.364-00:00"
   :updated_at "2022-05-15T14:07:30.364-00:00"
   :is_staff false
   :profile_picture "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"})

(def default-db
  {:logo "img/cartier_logo.svg"
   :logo-reversed "img/CARTIER_MyConcierge_Logo.svg"
   :company-name "Cartier"
   :product-name "Event Organizer"
   :last-error nil
   :loading? false
   :loading-refcount 0
   :signed-in? false
   :current-route nil
   :settings {:is-demo? false
              :userinfo {}
              :organization
              {:id "1cd0febe-81eb-4959-8f75-ae24a16263af"
               :name "Cartier"
               :url "https://cartier.event-organizer.dev"
               :created_at "2022-05-05T14:07:30.364-00:00"}}
   :notification {:title ""
                  :message ""
                  :is-open false}
   :user-guide {:is-open? false
                :page nil}
   :intervals {}
   :colors [{:id "red"
             :name "red"}
            {:id "blue"
             :name "blue"}
            {:id "green"
             :name "green"}
            {:id "yellow"
             :name "yellow"}
            {:id "orange"
             :name "orange"}
            {:id "violet"
             :name "violet"}
            {:id "gray"
             :name "gray"}
            {:id "navy"
             :name "navy"}
            {:id "beige"
             :name "beige"}
            {:id "pink"
             :name "pink"}]

   ;; Application models
   :roles [{:id "admin"
            :name "Admin"
            :permissions [{:resource :calendars
                           :action :edit}
                          {:resource :rooms
                           :action :edit}
                          {:resource :settings/events
                           :action :edit}
                          {:resource :settings/profile
                           :action :edit}
                          {:resource :settings/spaces
                           :action :edit}
                          {:resource :settings/roles
                           :action :edit}
                          {:resource :settings/users
                           :action :edit}
                          {:resource :settings/rooms
                           :action :edit}
                          {:resource :settings/bookings
                           :action :edit}]}
           {:id "staff"
            :name "Staff"
            :permissions [{:resource :calendars
                           :action :edit}
                          {:resource :rooms
                           :action :edit}
                          {:resource :settings/events
                           :action :edit}
                          {:resource :settings/profile
                           :action :edit}
                          {:resource :settings/spaces
                           :action :edit}
                          {:resource :settings/roles
                           :action :edit}
                          {:resource :settings/users
                           :action :edit}
                          {:resource :settings/rooms
                           :action :edit}
                          {:resource :settings/bookings
                           :action :edit}]}]


   :calendars []
   :spaces []
   :staffs []
   :space/shifts {}
   :events []

   ;; Event Organizer keys
   :event-organizer/events []
   :event-organizer/guests []
   :event-organizer/bookings []
   :event-organizer/rooms []
   :event-organizer/selected {:event-id nil}

   ;; Selected items accross the interface
   :selected {:space-id nil}

   ;; Whether the authentication is in progress:
   :auth0/loading? true

   ;; The profile data for the authenticated user (nil if no authenticated user):
   :auth0/user-data nil

   ;; The ID Token for the authenticated user (nil if no authenticated user):
   :auth0/user-id-token nil

   ;; The Access Token for the authenticated user (nil if no authenticated user):
   :auth0/user-access-token nil

   ;; The operation that caused the error
   ;; - nil (no error)
   ;; - :create-client
   ;; - :handle-callback
   ;; - :check-authentication
   ;; - :get-user-data
   ;; - :login
   ;; - :logout
   :auth0/error-stage nil

   ;; The error message:
   :auth0/error-message nil

   ;; Google Calendar for Japanese Holidays
   :google/holidays-jp []})

(defonce ls-key "tachikoma-dashboard-settings")  ;; localstore key

(defn settings->local-store
  "Puts settings into localStorage"
  [settings]
  (.setItem js/localStorage ls-key (str settings))) ;; map writen as an EDN map

(defn local-store-> []
  (.removeItem js/localStorage ls-key))

;; Register a coeffect handler which will load a value from localstore
;; To see it used look in events.clj at the event handler for `:boot`
(reg-cofx
 :local-store-settings
 (fn [cofx _]
   "Read in settings from localstore, and process into a map we can merge into app-db."
   (->> (some-> (.getItem js/localStorage ls-key)
                (read-string)                     ;; stored as an EDN map
                (js->clj :keywordize-keys true))  ;; handle nested #js structures
        (into (sorted-map))
        (assoc cofx :local-store-settings))))
